import { Resources } from './resources'

class PublishResource extends Resources {}

export default new PublishResource( 'publish' )


// WEBPACK FOOTER //
// ./src/resources/publish.js